import MuiLink from '@mui/material/Link';
import MuiList from '@mui/material/List';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import Spin from 'components/Spin';
import { NotificationIcon } from 'components/icons';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { updateNotification } from 'store/modules/notifications/actions';
import NotificationListItem from './NotificationListItem';

const Root = styled('div')(
  ({ theme }) => `
  height: 400px;
  width: 350px;
  display: flex;
  flex-direction: column;
  background-color: ${theme.palette.background.default};
  .list {
    overflow: auto;
    flex: 1;
  }
  .no-notif {
    display: flex;
    flex-direction: column;
    flex: 1;
    align-items: center;
    justify-content: center;
  }
`,
);

const Header = styled('div')`
  padding: 4px 10px;
  text-align: center;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);
  background-color: ${({ theme }) => theme.palette.background.paper};
  z-index: 1;
`;

const Footer = styled('div')`
  padding: 5px 10px;
  text-align: center;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);
  background-color: ${({ theme }) => theme.palette.background.paper};
`;

const NotificationsPopover = ({ account, popupState }) => {
  const [t] = useTranslation('notifications');
  const dispatch = useDispatch();
  const { data, loading } = useSelector((state) => state.notifications);

  const hideNotif = () => {
    popupState.close();
  };

  const markRead = (item) => {
    return dispatch(
      updateNotification({
        hash: item.hash,
        notifications_seen: '1',
      }),
    );
  };

  return (
    <Root>
      <Header>{t('notifications', 'Notifications')}</Header>
      <Spin spinning={loading} style={{ flex: 1 }}>
        {!data.length && !loading ? (
          <div className="no-notif">
            <NotificationIcon />
            <Typography color="textSecondary" variant="h4">
              {t('no-notifications', 'All caught up!')}
            </Typography>
          </div>
        ) : (
          <MuiList className="list">
            {data.map((i) => {
              return (
                <NotificationListItem
                  key={i.hash}
                  item={i}
                  onClick={hideNotif}
                  markRead={markRead}
                />
              );
            })}
          </MuiList>
        )}
      </Spin>
      <Footer>
        <MuiLink component={Link} onClick={hideNotif} to="/notifications">
          {t('view-all', 'View All')}
        </MuiLink>
      </Footer>
    </Root>
  );
};

export default NotificationsPopover;
